<div  class="header root">
  <div class="header-logo">
    <img class="logo-mobile" src="/assets/images/logo-mobile.svg" alt="Little Worker" />
    <img class="logo-pc" src="/assets/images/logo.svg" alt="Little Worker" />
    <span class="current-category">
      {{currentCategory}}
    </span>
  </div>

  <div class="menu" [ngClass]="{'menu-desktop': !displayMenu}">
    <app-menu></app-menu>
  </div>


  <div  *ngIf="user" class="header-user">
    <div class="quot-header-popup">
      <div class="quot-header-left-menu">
        <button type="button" (click)="showPopup()">
          <img class="logo" src="{{ user.avatar }}" />
          <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
        </button>
        <button (click)="displayMenuBurger()">
          <img *ngIf="!displayMenu" class="caret" src="/assets/images/menu-blue.svg" />
          <img *ngIf="displayMenu" class="caret" src="/assets/images/arrow-close-menu.svg" />
        </button>
      </div>

      <div class="quot-header-popup-body" id="myPopup">
        <span class="enabled" (click)="goToAccount()">
          <fa-icon [icon]="['fal', 'user']"></fa-icon>Mon profil
        </span>
        <span class="enabled deconnect" (click)="logout()">Se déconnecter</span>
      </div>
    </div>
  </div>
  <div class="menu-mobile" [ngClass]="{'menu-mobile-opened': displayMenu}">
    <app-menu [currentCategory]=currentCategory (closeMenu)="displayMenuBurger($event)"></app-menu>
  </div>
</div>
